import { supabase } from '../../../services/supabase';

export class BackupService {
  /**
   * Main backup function - creates a backup of all prompts and presets via Edge Function
   */
  static async createBackup(): Promise<{
    success: boolean;
    path?: string;
    error?: string;
  }> {
    try {
      // Call the Edge Function to handle backup
      const { data, error } = await supabase.functions.invoke(
        'backup-prompts',
        {
          body: {},
        }
      );

      if (error) {
        throw new Error(`Backup function error: ${error.message}`);
      }

      if (!data.success) {
        throw new Error(data.error || 'Backup failed');
      }

      return {
        success: true,
        path: data.path,
      };
    } catch (error) {
      console.error('Backup failed:', error);
      return {
        success: false,
        error:
          error instanceof Error ? error.message : 'Unknown error occurred',
      };
    }
  }

  /**
   * Get the Supabase dashboard URL for the backup bucket
   */
  static getDashboardUrl(): string {
    // Extract project ID from the Supabase URL
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    if (!supabaseUrl) {
      return '#';
    }

    // URL format: https://[project-id].supabase.co
    const match = supabaseUrl.match(/https:\/\/([^.]+)\.supabase\.co/);
    if (!match || !match[1]) {
      return '#';
    }

    const projectId = match[1];
    return `https://supabase.com/dashboard/project/${projectId}/storage/buckets/backup`;
  }
}
